import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTooltipContext } from './Context';
const Content = forwardRef(({ as: Element = 'div', className, children, render, ...rest }, ref) => {
    const { id, isOpen, setIsOpen, position } = useTooltipContext();
    return (_jsx(Element, { className: typeof className === 'function' ? className({ isOpen }) : className, "data-open": isOpen, "data-position": position, hidden: !isOpen, id: `${id}-content`, ref: ref, role: "tooltip", ...rest, children: render ? render({ isOpen, close: () => setIsOpen(false) }) : children }));
});
Content.displayName = 'Content';
export { Content };
//# sourceMappingURL=Content.js.map